import { Component, OnInit ,ViewChild} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../_models';
import { UserService } from '../_services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/_services/notification.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-all-users',
  templateUrl: './all-users.component.html',
  styleUrls: ['./all-users.component.css']
})
export class AllUsersComponent implements OnInit {

  displayedColumns: string[] = [ 'no','firstname','lastname',  'mobile','email', 'status','tool'];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  total : number;
  dataSource;
  arr;
  title = 'materialApp'; 
  color = 'primary';
  mode = 'indeterminate';
  value = 75;
  diameter=60
  loading = true;
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  public userId :  string
  public userStatus : string ;
  public userRole : string ;

  constructor(public userService: UserService,
    private route: ActivatedRoute,
    private notifyService : NotificationService,
    private router: Router) { }

  ngOnInit(): void {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
    this.userId =  this.currentUserSubject.value.userId;

    // this.total = 0;
    this.userStatus = 'Active';
    this.userRole = 'Admin';
    this.getAllUsers();
    this.dataSource.paginator = this.paginator;    

  }

  getAllUsers(){
    this.loading = true;
    this.userService.getAllUsers(this.userStatus,this.userRole).subscribe(
      res => {    
        // this.dataSource = <any>res;  
        // this.total = this.dataSource.length;   
        this.arr = res  
        this.dataSource = new MatTableDataSource(this.arr);  
        this.dataSource.paginator = this.paginator;    
        this.total =  this.arr.length;  
        this.loading = false ;         
      },
      error => {
        this.loading = false;
      
    });
  }

  OnEditClick(userId : string){
    this.router.navigate(['/user-detail', userId]);
  }

  DeActivateCustomer(userId : string) {
             
    var sureToDeactivate =  confirm("Are you sure to deactivate this user?");

    if(sureToDeactivate){
      if(userId){
        this.userService.DeActivateUser(userId)
        .subscribe( 
            data => {              
              if(data){             
                this.notifyService.showSuccess("Saved successfully", "CSP Portal");   
                this.getAllUsers();                         
            }
          },
          error => {                
          
          });          
      }
    }  
  }

  DeleteCustomer(userId : string) {
             
    var sureToDelete =  confirm("Are you sure to delete this user?");

    if(sureToDelete){
      if(userId){
        this.userService.DeleteUser(userId)
        .subscribe( 
            data => {                            
              if(data){      
                this.getAllUsers();       
                this.notifyService.showSuccess("Deleted successfully", "CSP Portal");                            
            }
          },
          error => {                
          
          });          
      }
    }  
  }

  OnStatusChange(){  
    this.getAllUsers();
  }

  OnRoleChange(){
    this.getAllUsers();
  }

}
